export interface Testimonial {
  quote: string
  author: string
  role: string
  location: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'Planifiqué mi año escolar completo en una tarde. Ahora cada clase tiene un objetivo claro y mis alumnos me piden que no termine. Cambió todo.',
    author: 'Mariana T.',
    role: 'Docente de EF',
    location: 'Buenos Aires',
  },
  {
    quote:
      'Mis alumnos mejoraron en dos meses más que en todo el año anterior. La progresión tiene sentido pedagógico real: no es solo “jugar”.',
    author: 'Carlos M.',
    role: 'Profesor de EF',
    location: 'Córdoba',
  },
  {
    quote:
      'Dejé de buscar actividades en YouTube. Abro el MEGAPACK y está todo: sesiones, evaluaciones, rúbricas y juegos. Libertad real.',
    author: 'Sofía L.',
    role: 'Directora de EF',
    location: 'Rosario',
  },
  {
    quote:
      'Como profe de una escuela pública sin presupuesto, este kit es oro. Cero material y máxima calidad pedagógica, adaptado a nuestra realidad.',
    author: 'Roberto G.',
    role: 'Docente',
    location: 'La Plata',
  },
  {
    quote:
      'Las rúbricas me salvaron. Hablo con las familias en competencias desarrolladas y números reales, no en conversaciones vagas sobre conducta.',
    author: 'Andrea P.',
    role: 'Coordinadora',
    location: 'Mendoza',
  },
  {
    quote:
      'Como docente nuevo, esto me dio un sistema profesional desde el día 1. Mi confianza en el patio se multiplicó y los alumnos lo notan.',
    author: 'Juan P.',
    role: 'Profesor nuevo',
    location: 'San Juan',
  },
]
